module.exports = {"451221100":"城关镇","451221101":"大厂镇","451221102":"车河镇","451221103":"芒场镇","451221104":"六寨镇","451221105":"月里镇","451221106":"吾隘镇","451221107":"罗富镇","451221202":"中堡苗族乡","451221203":"八圩瑶族乡","451221204":"里湖瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451221.json
// module id = 2289
// module chunks = 0